import { DashboardFilterConfigType } from "../types";

export enum DashboardFilterActions {
	CHANGE_DATE_FILTER = "CHANGE_DATE_FILTER",
	CHANGE_ORGANIZATIONS_FILTER = "CHANGE_ORGANIZATIONS_FILTER",
	CHANGE_ALL_SELECTED_FILTERS = "CHANGE_ALL_SELECTED_FILTERS",
}

export const filtersConfigReducer = (
	state: DashboardFilterConfigType,
	action: Record<string, any>
): DashboardFilterConfigType => {
	switch (action.type) {
		case DashboardFilterActions.CHANGE_ALL_SELECTED_FILTERS:
			return { ...state, selectedFilter: action.data };
		case DashboardFilterActions.CHANGE_DATE_FILTER:
			return {
				...state,
				selectedFilter: {
					...state.selectedFilter,
					dateRange: action.data,
				},
			};
		case DashboardFilterActions.CHANGE_ORGANIZATIONS_FILTER:
			return {
				...state,
				selectedFilter: {
					...state.selectedFilter,
					organizationIds: action.data,
				},
			};
		default:
			return state;
	}
};
